"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_qr__code(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f7844d52-dcc3-4566-b7d0-fb043daa57f2",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "qr-code-hi"), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,56a4,4,0,0,1-4-4V28a4,4,0,0,1,4-4H52a4,4,0,0,1,0,8H32V52A4,4,0,0,1,28,56Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,53.67a4,4,0,0,1-4-4V52a4,4,0,0,0,8,0V49.67A4,4,0,0,1,28,53.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,29.67H32V32H52a4,4,0,0,0,4-4,4.21,4.21,0,0,0-.19-1.17A4,4,0,0,1,52,29.67Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52,168H28a4,4,0,0,1-4-4V140a4,4,0,0,1,8,0v20H52a4,4,0,0,1,0,8Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,165.83H28a4,4,0,0,1-4-4V164a4,4,0,0,0,4,4H52a4,4,0,0,0,4-4,3.59,3.59,0,0,0-.17-1.08A4,4,0,0,1,52,165.83Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164,56a4,4,0,0,1-4-4V32H140a4,4,0,0,1,0-8h24a4,4,0,0,1,4,4V52A4,4,0,0,1,164,56Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,53.67a4,4,0,0,0,4-4V52a4,4,0,0,1-8,0V49.67A4,4,0,0,0,164,53.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,29.67h20V32H140a4,4,0,0,1-4-4,4.21,4.21,0,0,1,.19-1.17A4,4,0,0,0,140,29.67Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164,168H140a4,4,0,0,1,0-8h20V140a4,4,0,0,1,8,0v24A4,4,0,0,1,164,168Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140,165.83h24a4,4,0,0,0,4-4V164a4,4,0,0,1-4,4H140a4,4,0,0,1-4-4,3.59,3.59,0,0,1,.17-1.08A4,4,0,0,0,140,165.83Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 104,
    width: 24,
    height: 24,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 40,
    height: 40,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 104,
    width: 40,
    height: 40,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 48,
    width: 40,
    height: 40,
    fill: "#666"
  }));
}

var _default = ic_qr__code;
exports.default = _default;